const About = () => {
  return (
    <div className="container">
      <h1>About Us</h1>
      <p>
        Welcome to Capronik, your one-stop destination for all your furniture
        needs. We are a passionate team dedicated to providing high-quality,
        stylish, and affordable furniture that transforms your living spaces
        into havens of comfort and elegance.
      </p>
      <p>
        At Capronik, we believe that furniture is not just about functionality;
        it's about creating an environment that reflects your personality and
        enhances your lifestyle. Our extensive collection includes a wide range
        of furniture pieces, from classic to contemporary designs, ensuring that
        you find the perfect fit for your home.
      </p>
      <p>
        We take pride in our commitment to quality craftsmanship and customer
        satisfaction. Each piece of furniture in our collection is carefully
        curated to meet our high standards of durability, aesthetics, and
        affordability. Whether you're furnishing a cozy apartment or a spacious
        house, Capronik has something for everyone.
      </p>
      <p>
        Our team of experienced designers and customer service representatives
        is always ready to assist you in finding the ideal furniture pieces that
        suit your taste and budget. We also offer personalized design
        consultations to help you create a cohesive and stylish look for your
        home.
      </p>
      <p>
        Thank you for choosing Capronik as your trusted furniture partner. We
        look forward to helping you create a beautiful and comfortable living
        space that you can call home.
      </p>
    </div>
  );
};

export default About;
